export default {
  colorSwatches: {
    id: 'color_swatches_label',
    defaultMessage: 'Color: {color}',
  },
  availableColors: {
    id: 'color_swatches_available_colors',
    defaultMessage: 'Available colors: {colors}',
  },
  moreColors: {
    id: 'color_swatches_more',
    defaultMessage: 'more colors',
  },
} as const
